<template>
    <div class="all">
        <van-nav-bar
                title="教程列表"
                left-text="返回"
                right-text
                left-arrow
                @click-left="$goBack()"
                @click-right
        />
        <div class="body">
            <div v-for="course in courseList" :key="course.id" class="course">
                <router-link :to="'/main/university/courseDetail?courseId=' + course.id">
                    <van-row>
                        <van-col span="6" v-if="course.logo">
                            <img :src="course.logo"/>
                        </van-col>
                        <van-col span="6" v-if="!course.logo">
                            <img :src="logo"/>
                        </van-col>
                        <van-col span="12"><p>{{course.name}}</p></van-col>
                    </van-row>
                </router-link>
            </div>
        </div>
    </div>
</template>

<script>
    import logo from '@/assets/logo.jpg';
    import courseAPI from '@/api/course';

    export default {
        data() {
            return {
                logo: logo,
                query: {
                    classify: this.$route.query.classify,
                },
                courseList: {},
            }
        },
        created() {
            this.queryCourseList();
        },
        methods: {
            queryCourseList() {
                this.$toast.loading({forbidClick: true});

                courseAPI.queryCourseList(this.query).then((result) => {
                    this.courseList = result.data;
                    this.$toast.clear();
                })
            },
        }
    }
</script>

<style lang="scss" scoped>
    .all {
        background-color: #fff;
    }

    .body {
        margin: 3rem 2rem;
        p {
            text-align: center;
        }
        img {
            top: 10%;
            left: 15%;
            position: relative;
        }

    }

    .course {
        font-size: 1.6rem;
        padding: 1rem 1rem 1rem 1rem;
        margin: 1rem 1rem 1rem 1rem;
        border-left: 3px solid #ee9900;
        -moz-box-shadow: 0 0 10px #e5e5e5;
        -webkit-box-shadow: 0 0 10px #e5e5e5;
        box-shadow: 0 0 10px #e5e5e5;

        .van-row {
            img {
                height: 4rem;
                width: 4rem;
            }

            p {
                text-align: left;
                margin-top: 1rem;
            }
        }
    }
</style>